module.exports = __webpack_public_path__ + "static/media/water_descovered_on_mars.fe27a1ee.jpg";